function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useCallback, useState } from 'react';
import { useApi } from '@deephaven/jsapi-bootstrap';
import { getSize } from '@deephaven/jsapi-utils';
import useTableListener from "./useTableListener.js";
/**
 * React hook that returns the size of a given table or zero if table is null or
 * undefined. The hook subscribes to the dh.Table.EVENT_SIZECHANGED event and
 * triggers a re-render if any events are received to ensure we have the current
 * size.
 * @param table The table to check the size on.
 */
export function useTableSize(table) {
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    forceRerender = _useState2[1];
  var dh = useApi();
  var onSizeChanged = useCallback(() => {
    forceRerender(i => i + 1);
  }, []);
  useTableListener(table, dh.Table.EVENT_SIZECHANGED, onSizeChanged);
  return getSize(table);
}
export default useTableSize;
//# sourceMappingURL=useTableSize.js.map